<template>
  <DialogWrapper
    close-on-cancel
    class="contact-candidate-dialog"
    :show.sync="show"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title`"
    :saveBtnLabelI18nKey="`${i18nPrefix}.btn.send`"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      :model="contactInfo"
      :formLines="formLines"
    ></WrappedForm>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    jobId: {
      required: false
    },
    candidateIds: {
      required: true
    },
    isAllCandidate: {
      required: false
    },
    searchParams: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.contactCandidate',
      show: false,
      loading: false,
      contactInfo: {}
    }
  },
  computed: {
    formLines () {
      const i18nPrefix = this.i18nPrefix
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        subject: {
          label: this.$t(`${i18nPrefix}.label.subject`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        content: {
          label: this.$t(`${i18nPrefix}.label.content`),
          props: { type: 'textarea', autosize: { minRows: 5 } },
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      }
      return lines
    },
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    ...mapActions('application', ['contactCandidate']),
    openDialog () {
      this.show = true
    },
    clearForm () {
      this.contactInfo = {}
      this.$nextTick(() => {
        this.form.clearValidate()
      })
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      const contactInfo = {
        search_params: this.searchParams,
        is_all_application: this.isAllApplication,
        job_id: this.jobId,
        candidate_ids: this.candidateIds,
        subject: this.contactInfo.subject,
        content: this.contactInfo.content
      }
      const resp = await this.contactCandidate(contactInfo)
      if (resp) {
        this.loading = false
        if (resp.send_count > 0) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.sendSuccess`))
          this.$emit('success')
          this.show = false
        } else if (resp.no_email_count > 0) {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.noEmailAccount`))
        } else {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.sendFail`))
        }
      }
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
